(function(config) {
    'use strict';

    angular.module('appliances.services', [
            'ngResource'
        ])
        .factory('appliancesDataSrvc', appliancesDataSrvc)
        .factory('appliancesSrvc', appliancesSrvc);

    appliancesDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function appliancesDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/appliances/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            productAppliances: {
                url: config.api + '/api/v1/appliances/admin_product_appliances/',
                isArray: true,
                method: 'GET'
            }
        });
    }

    appliancesSrvc.$inject = ['appliancesDataSrvc', 'modalSrvc'];

    function appliancesSrvc(appliancesDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    appliancesDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }
})(window.config);
